import firebase from 'firebase/app'
import 'firebase/analytics'
import { config } from './config'

/**
 * Provide a safe analytics interface even when Firebase env vars are missing.
 * This prevents runtime crashes like:
 *   FirebaseError: Installations: Missing App configuration value: "apiKey"
 */

// Minimal keys we require before attempting initialization
const requiredKeys: (keyof typeof config)[] = ['apiKey', 'projectId']
const hasRequiredConfig = requiredKeys.every(k => !!config[k])

// Default stub (used when config is incomplete or initialization fails)
let analyticsExport: { logEvent: (...args: any[]) => void } = {
  logEvent: (...args: any[]) => console.debug('[analytics stub] logEvent:', ...args),
}

if (hasRequiredConfig) {
  try {
    if (!firebase.apps.length) {
      firebase.initializeApp(config)
      console.log('[firebase] initialized')
    }
    if (typeof firebase.analytics === 'function') {
      analyticsExport = firebase.analytics()
    } else {
      console.warn('[firebase] analytics() not available, using stub')
    }
  } catch (e) {
    console.warn('[firebase] initialization failed, using analytics stub:', e)
  }
} else {
  console.warn(
    '[firebase] incomplete config (missing apiKey / projectId). Skipping init, using analytics stub.',
  )
}

export const analytics = analyticsExport
